import { Component, computed, HostBinding, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import {
  CoreJssProxyModule,
  ImageField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { TrackLinkDirective } from '@analytics/events';
import type { A11YLinkField } from '@core/jss-models';

@Component({
  selector: 'wl-information-card',
  standalone: true,
  imports: [
    CoreJssProxyModule,
    CrntButtonAlt,
    RichTextWrapperComponent,
    GenericLinkDirective,
    TrackLinkDirective,
  ],
  templateUrl: './information-card.component.html',
  styleUrls: [
    './information-card.component.ed.scss',
    './information-card.component.essent.scss',
  ],
})
export class InformationCardComponent {
  readonly title = input.required<TextField>();
  readonly content = input.required<RichTextField>();
  readonly button = input.required<A11YLinkField>();
  readonly image = input<ImageField>();
  readonly aspectRatio = input.required<AspectRatio>();

  readonly #fieldService = inject(FieldService);

  readonly showContent = computed(() =>
    this.#fieldService.showTextField(this.content())
  );

  readonly showImage = computed(() =>
    this.#fieldService.showImageField(this.image())
  );

  @HostBinding('style.--aspect-ratio')
  protected get computedAspectRatio(): string {
    return this.aspectRatio();
  }
}

export type AspectRatio = '4/3' | '1/1';
